module.exports = __webpack_public_path__ + "static/img/9.4572358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/9.png
// module id = B1lA
// module chunks = 1